import React from 'react';
import { CheckIcon, HeartIcon, StarIcon } from 'lucide-react';
export const Benefits = () => {
  const benefits = ['Qué nadie te explicó del postparto (y cómo prepararte emocionalmente).', 'Rituales de autocuidado de 10 minutos, incluso con tu bebé en brazos.', 'Ejercicios de reconexión cuerpo-mente (sin mística, con amor).', 'Un plan preparto para que no te tome por sorpresa.', 'Una checklist que te recuerda esto: Tu bienestar no es opcional.'];
  const solutions = [{
    title: 'Recupera tu energía',
    description: 'Aprende técnicas simples para recargar tu energía, incluso cuando el sueño es escaso. Descubre cómo pequeños momentos de autocuidado pueden transformar tus días.'
  }, {
    title: 'Reconecta con tu cuerpo',
    description: 'Ejercicios suaves y prácticos para volver a habitar tu cuerpo con amor, respetando sus tiempos y celebrando su sabiduría.'
  }, {
    title: 'Gestiona tus emociones',
    description: 'Herramientas para navegar la montaña rusa emocional del postparto sin culpa, con comprensión y con el permiso para sentir todo lo que necesites sentir.'
  }, {
    title: 'Encuentra tu equilibrio',
    description: 'Estrategias para balancear el cuidado de tu bebé y tu autocuidado, sin sentirte egoísta por priorizar tu bienestar.'
  }];
  return <section className="w-full bg-white py-16 px-4" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <div className="flex flex-col lg:flex-row items-center gap-12" data-id="element-19">
          <div className="w-full lg:w-1/2 space-y-6" data-id="element-20">
            <h2 className="text-3xl font-serif font-medium text-[#444]" data-id="element-21">
              El cuerpo cambió. Tu mente se siente como niebla.
            </h2>
            <p className="text-lg text-[#5a5553]" data-id="element-22">
              Y entre pañales y tomas, una pregunta aparece, cada noche, sin
              falta:
            </p>
            <p className="text-xl text-[#8e7f7a] italic font-light" data-id="element-23">
              "¿Y yo… dónde quedé?"
            </p>
            <p className="text-[#5a5553]" data-id="element-24">
              Esto no significa que estés mal. Significa que estás renaciendo.
              Pero sin mapa. Sin tribu. Y sin permiso para decirlo en voz alta.
            </p>
            <p className="text-[#5a5553]" data-id="element-25">
              No estás sola. No estás rota. Solo nadie te enseñó a sostenerte a
              ti.
            </p>
            <p className="font-medium text-[#5a5553]" data-id="element-26">Por eso creamos esto.</p>
            <p className="text-[#5a5553]" data-id="element-27">
              No es un curso. No es teoría. Es un bálsamo para tu alma. Un
              ritual. Un sostén. Una vuelta a casa.
            </p>
          </div>
          <div className="w-full lg:w-1/2 bg-[#f8f2ee] p-8 rounded-lg" data-id="element-28">
            <h3 className="text-2xl font-serif font-medium text-[#444] mb-6" data-id="element-29">
              💎 Dentro de esta guía descubrirás:
            </h3>
            <ul className="space-y-4" data-id="element-30">
              {benefits.map((benefit, index) => <li key={index} className="flex items-start gap-3" data-id="element-31">
                  <CheckIcon size={20} className="text-[#d4b7a8] mt-1 flex-shrink-0" data-id="element-32" />
                  <span className="text-[#5a5553]" data-id="element-33">✔ {benefit}</span>
                </li>)}
            </ul>
            <div className="mt-8" data-id="element-34">
              <h3 className="text-2xl font-serif font-medium text-[#444] mb-4" data-id="element-35">
                🔥 ¿Por qué esto funciona?
              </h3>
              <p className="text-[#5a5553]" data-id="element-36">
                Porque fue escrito en medio de lágrimas reales. En noches sin
                dormir. Desde el barro. No desde la teoría.
              </p>
              <p className="text-[#5a5553] mt-3" data-id="element-37">
                No hay juicios. No hay "deberías". Solo verdad. Herramientas. Y
                un recordatorio suave: No puedes dar lo mejor… si te dejas para
                el final.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-20" data-id="element-38">
          <div className="text-center mb-12" data-id="element-39">
            <h2 className="text-3xl md:text-4xl font-serif font-medium text-[#444] mb-4" data-id="element-40">
              ✨ Lo que te espera después de leer este ebook
            </h2>
            <p className="text-lg text-[#8e7f7a] max-w-3xl mx-auto" data-id="element-41">
              No solo es información. Es una transformación. Una hoja de ruta
              para volver a ti mientras cuidas a tu bebé.
            </p>
          </div>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-42">
            {solutions.map((solution, index) => <div key={index} className="bg-[#f8f2ee] p-6 rounded-lg border-l-4 border-[#d4b7a8]" data-id="element-43">
                <h3 className="text-xl font-serif font-medium text-[#444] mb-3 flex items-center gap-2" data-id="element-44">
                  <StarIcon size={18} className="text-[#d4b7a8]" data-id="element-45" />
                  {solution.title}
                </h3>
                <p className="text-[#5a5553]" data-id="element-46">{solution.description}</p>
              </div>)}
          </div>
          <div className="bg-white border border-[#d4b7a8] rounded-lg p-6 mt-10" data-id="element-47">
            <div className="flex items-start gap-4" data-id="element-48">
              <HeartIcon size={24} className="text-[#c08676] mt-1 flex-shrink-0" data-id="element-49" />
              <div data-id="element-50">
                <h3 className="text-xl font-serif font-medium text-[#444] mb-2" data-id="element-51">
                  Después de este viaje, te sentirás...
                </h3>
                <p className="text-[#5a5553] mb-4" data-id="element-52">
                  Más conectada contigo misma. Con herramientas prácticas para
                  cuidarte cada día. Con la certeza de que tus necesidades
                  importan. Con la paz de saber que no estás fallando — estás
                  aprendiendo. Y con un plan claro para integrar el autocuidado
                  en tu nueva vida como mamá.
                </p>
                <p className="text-[#5a5553] italic" data-id="element-53">
                  "Este ebook no es solo una guía, es un abrazo en los días
                  difíciles y un recordatorio de que mereces cuidarte tanto como
                  cuidas a tu bebé."
                </p>
              </div>
            </div>
          </div>
          <div className="text-center mt-10" data-id="element-54">
            <a href="https://mamaplena.com/cart/58296384749649:1" className="inline-block bg-[#c08676] hover:bg-[#a86256] text-white font-medium py-3 px-6 rounded-md transition-all shadow-sm text-lg" target="_blank" rel="noopener noreferrer" data-id="element-55">
              Quiero transformar mi experiencia postparto
            </a>
          </div>
        </div>
      </div>
    </section>;
};